import { apiUri } from '../appConfig';

const facilityList = (marked) => (
	fetch(`${apiUri}/facilities${marked ? '/index' : ''}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default facilityList;



// WEBPACK FOOTER //
// ./src/js/request/facilityList.js